export default __webpack_public_path__ + "static/media/instant_advent.d1bcc099.png";